<template>
  <main>
    <vue-progress-bar></vue-progress-bar>
    <transition mode="out-in">
      <router-view />
    </transition>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :bottom="true"
      :right="true"
    >
      <span v-html="snackbar.message"></span>
      <v-btn light text @click="snackbar.show = false">X</v-btn>
    </v-snackbar>
  </main>
</template>

<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
<script>
import axios from "axios";
// checks to see if auth jwt token is valid or has expired, if it gets back 401 error log out
export default {
  computed: {
    snackbar: {
      get() {
        return this.$store.getters.snackbar;
      },
      set(val) {
        this.$store.commit("setSnackbar", { val });
      },
    },
  },
  data() {
    return {
      inboxtimer: null,
    };
  },
  created: function () {
    this.$http.interceptors.response.use(
      (response) => {
        this.$Progress.finish();
        return response;
      },
      (error) => {
        this.$Progress.finish();
        if (401 === error.response.status) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });

          // if (this.$store.getters.authorized) {
          //   this.$store.dispatch("refreshtoken");
          // } else {
          //   this.$router.push("/login");
          //   return Promise.reject(error);
          // }
        } else if (412 == error.response.status) {
          this.$router.push("/expired");
        } else {
          let errorMessage = "";
          if (error.response.data.message)
            errorMessage = error.response.data.message;
          else
            errorMessage = error.response.data.error.details
              .map((p) => p.message)
              .join("<br/>");

          this.$store.dispatch("showErrorMessage", errorMessage);          
        }
        return Promise.reject(error);
      }
    );
    let timer = 5 * 60 * 1000;
    this.inboxtimer = setInterval(() => {
      let hasinbox =
        this.$store.getters.usermenu.filter((item) => {
          return item.textkey == "inbox";
        }).length > 0;
      if (hasinbox && this.$store.getters.authorized) {
        this.$store.dispatch("updateInboxCount");
      }
    }, timer);
  },
  beforeDestroy() {
    clearInterval(this.inboxtimer);
  },
  methods: {},
};
</script>
<style>
.v-dialog > .v-card > .v-card__text {
  padding: 24px 20px 0px !important;
}
</style>